import React from 'react';

/**
 * QuoteOptionTabs
 *
 * Renders a tabbed navigation bar for comparing multiple AI-generated
 * quote options (e.g. "Value Package", "Deluxe Package", "Luxury Package").
 * Only renders when there is more than one option in the group.
 *
 * Props:
 * - options: Array<{ id: number|string, optionName: string, totalPrice: number }>
 * - activeIndex: number - index of the currently active option
 * - onSelect: (index: number) => void - called when the agent clicks a tab
 */
const QuoteOptionTabs = ({ options, activeIndex, onSelect }) => {
  if (!Array.isArray(options) || options.length <= 1) {
    return null;
  }

  return (
    <div className="quote-option-tabs">
      <div className="quote-option-tabs-header">
        <span className="quote-option-tabs-icon">🤖</span>
        <span className="quote-option-tabs-label">AI-Generated Options — Compare &amp; Edit</span>
      </div>
      <div className="quote-option-tabs-list">
        {options.map((option, index) => (
          <button
            key={option.id || index}
            type="button"
            className={`quote-option-tab ${index === activeIndex ? 'active' : ''}`}
            onClick={() => onSelect(index)}
          >
            <span className="quote-option-tab-name">
              {option.optionName || `Option ${index + 1}`}
            </span>
            {typeof option.totalPrice === 'number' && (
              <span className="quote-option-tab-price">
                ${option.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuoteOptionTabs;
